// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"24":"companies","644":"account"}[chunkId] || chunkId) + "." + {"24":"bc890bf8","393":"5a6ce419","482":"01626715","644":"a79f9200"}[chunkId] + ".js";
};